import { render, staticRenderFns } from "./ItemsDispatch.vue?vue&type=template&id=9296bf96&scoped=true&"
import script from "./ItemsDispatch.vue?vue&type=script&lang=js&"
export * from "./ItemsDispatch.vue?vue&type=script&lang=js&"
import style0 from "./ItemsDispatch.vue?vue&type=style&index=0&id=9296bf96&lang=scss&scoped=true&"
import style1 from "./ItemsDispatch.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9296bf96",
  null
  
)

export default component.exports